export default __webpack_public_path__ + "static/media/instagram_3.6d6c8fa9.png";